<template>
  <div>
    <b-row>
      <b-col>
        <h4>{{ type | capitalize }} items - {{ sItems.length }}</h4>
      </b-col>
      <b-col>
        <div v-if="checkTypeState(step, type)" class="text-right">
          <i class="fa fa-circle text-green f-s-8 mr-2"></i>
          Confirmed
        </div>
        <div v-else class="text-right">
          <i class="fa fa-circle text-red f-s-8 mr-2"></i>
          Unconfirmed
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-list-group v-if="sItems.length">
          <b-list-group-item
            v-for="sItem in sItemsWithCalculatedValues"
            :key="sItem.id"
            class="bg-light p-b-15"
          >
            <b-row>
              <b-col lg="3" class="text-center">
                <h5>{{ sItem.item.name }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3" class="text-center">
                <img
                  :src="getImage(sItem.item)"
                  :width="'100%'"
                  style="max-width: 125px"
                />
              </b-col>
              <b-col cols="9">
                <div>
                  <div v-if="sItem.description">
                    <b>{{ descriptionLabel }}:</b> {{ sItem.description }}
                  </div>
                  <div v-if="sItem.startTime && sItem.endTime">
                    <b>{{ timeLabel }}:</b> {{ sItem.startTime }} -
                    {{ sItem.endTime }}
                  </div>
                  <div v-if="sItem.remarks">
                    <b>Remarks:</b> {{ sItem.remarks }}
                  </div>
                  <div
                    v-if="
                      (type == 'staff' && sItem.requirements) ||
                      (type == 'service' && sItem.requirements)
                    "
                  >
                    <b>{{ requirementsLabel }}:</b> {{ sItem.requirements }}
                  </div>
                </div>
                <b-table :items="[sItem]" :fields="fields">
                  <template v-slot:head(subcategory)>
                    {{ getSubcategoryLabel(type) }}
                  </template>
                  <template v-slot:head(category)>
                    {{ getCategoryLabel(type) }}
                  </template>
                  <template v-slot:cell(required)="{ item }">
                    {{ item.amount }}
                  </template>
                  <template v-slot:cell(costEstimate)="{ item }">
                    {{ item.costEstimate }}
                  </template>
                  <template v-slot:cell(total)="{ item }">
                    {{ item.item.amount }}
                  </template>
                  <template v-slot:cell(subcategory)="{ item }">
                    {{
                      categoryName(item.item.category)
                        ? categoryName(item.item.category)
                        : '-'
                    }}
                  </template>
                  <template v-slot:cell(category)="{ item }">
                    {{
                      categoryParent(item.item.category)
                        ? categoryParent(item.item.category)
                        : '-'
                    }}
                  </template>
                  <template v-slot:cell(source)="{ item }">
                    {{ item.item.source }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
        <b-list-group v-else>
          <b-list-group-item class="bg-light">
            {{ checkTypeState(step, type) ? 'No items required' : 'No items' }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['step', 'type', 'sItems', 'categories', 'getFullItem'],
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data() {
    return {
      fields: [
        { key: 'required' },
        { key: 'costEstimate', label: 'Unit price' },
        { key: 'totalCostEstimate', label: 'Cost estimate total' },
        { key: 'total', label: 'Items total' },
        { key: 'subcategory' },
        { key: 'category' },
        { key: 'source' }
      ],
      descriptionLabel: '',
      timeLabel: '',
      requirementsLabel: ''
    }
  },
  computed: {
    sItemsWithCalculatedValues() {
      return this.sItems.map((sItem) => {
        sItem.totalCostEstimate = sItem.amount * sItem.costEstimate
        return sItem
      })
    }
  },
  methods: {
    getImage(item) {
      var fullItem = this.getFullItem(item.id)
      var image = fullItem.image
      if (image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    goToScript(step, typeName) {
      this.$router.push(`/script/${typeName}/${step.id}`)
    },
    checkTypeState(step, typeParam) {
      switch (typeParam) {
        case 'space':
          return this.step.space
        case 'stuff':
          return this.step.stuff
        case 'staff':
          return this.step.staff
        case 'service':
          return this.step.service
        default:
          break
      }
    },
    getCategoryLabel() {
      switch (this.type) {
        case 'space':
          return 'Venue'
        case 'stuff':
          return 'Main category'
        case 'staff':
          return 'Group'
        case 'service':
          return 'Category'
        default:
          break
      }
    },
    getSubcategoryLabel() {
      switch (this.type) {
        case 'space':
          return 'Area'
        case 'stuff':
          return 'Subcategory'
        case 'staff':
          return 'Team'
        case 'service':
          return 'Area'
        default:
          break
      }
    },
    categoryName(currentCategory) {
      if (currentCategory) {
        let category = this.categories.filter((category) => {
          return currentCategory == category.id
        })
        return category[0].name
      } else {
        return ''
      }
    },
    categoryParent(currentCategory) {
      if (currentCategory) {
        let category = this.categories.filter((category) => {
          return currentCategory == category.id
        })
        return category[0].parent.name
      } else {
        return ''
      }
    },
    updateLabels() {
      switch (this.type) {
        case 'space':
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Event time of use'
          break
        case 'stuff':
          this.descriptionLabel = 'Intended use'
          this.timeLabel = 'Time of use'
          break
        case 'staff':
          this.descriptionLabel = 'Job description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Job requirements'
          break
        case 'service':
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Tasks to be done'
          break
        default:
          break
      }
    }
  },
  mounted() {
    this.updateLabels()
  }
}
</script>
